export const MOVE_TO_TOP = 'MOVE_TO_TOP' as const;
export const MOVE_UP = 'MOVE_UP' as const;
export const MOVE_DOWN = 'MOVE_DOWN' as const;
export const MOVE_TO_BOTTOM = 'MOVE_TO_BOTTOM' as const;

export type MenuItemReorderOperation =
	| typeof MOVE_TO_TOP
	| typeof MOVE_UP
	| typeof MOVE_DOWN
	| typeof MOVE_TO_BOTTOM;
